import { EQuizMode } from '@constants';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { QuizOption } from '../QuizOption';

import { ModeSkeleton } from './ModeSkeleton';
import { Wrapper } from './QuizModes.styles';

import FLASHCARDS_IMAGE from '@/assets/flashcards.png';
import { useGetAvailableQuizModesForStudent } from '@/store';

const IMG_SIZE = 50;
const EmojiIcon = {
  [EQuizMode.QUIZ]: '🎯',
  [EQuizMode.LIGHTNING]: '⚡️',
  [EQuizMode.TRUE_FALSE]: '🏓',
  [EQuizMode.PRACTICE]: '⏳',
  [EQuizMode.PRACTICAL_CASE]: '📋'
};

export const QuizModes = () => {
  const { t } = useTranslation('StudentQuizzesTranslations');
  const navigateTo = useNavigate();

  const { availableQuizModes, isLoading } = useGetAvailableQuizModesForStudent();
  const handleNavigateToQuizConfiguration = (mode: EQuizMode) => {
    navigateTo(`/tests/configuration?mode=${mode}`);
  };
  const handleNvigateToFlashcards = () => {
    navigateTo('/tests/flashcards');
  };

  if (isLoading) return <ModeSkeleton />;

  if (!availableQuizModes) return null;

  return (
    <Wrapper>
      {Object.keys(availableQuizModes).map(mode => {
        const isAvailable = availableQuizModes[mode as EQuizMode];
        if (!isAvailable) return null;
        return (
          <QuizOption
            key={mode}
            icon={EmojiIcon[mode as EQuizMode]}
            title={t(`${mode as EQuizMode}_MODE_TITLE`)}
            description={t(`${mode as EQuizMode}_MODE_DESCRIPTION`)}
            onClick={() => handleNavigateToQuizConfiguration(mode as EQuizMode)}
          />
        );
      })}
      <QuizOption
        icon={<img src={FLASHCARDS_IMAGE} alt="flashcards" width={IMG_SIZE} height={IMG_SIZE} />}
        title={t('FLASHCARDS_MODE_TITLE')}
        description={t('FLASHCARDS_MODE_DESCRIPTION')}
        onClick={() => handleNvigateToFlashcards()}
      />
    </Wrapper>
  );
};
